import type { FC } from "react";
import { useMemo } from "react";

import { ShareBarCell } from "@similarweb/pro-logic-components";

import { translate } from "app/filters/i18nFilter";
import { abbrNumberFilter } from "app/filters/ngFilters";
import {
    DEFAULT_SENTIMENT,
    SENTIMENT_COLOR_SET,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMConsts";
import type { ISentiment } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

import type { ITopicSentimentTableRow } from "./types";

export const TopicShareBar: FC<ITopicSentimentTableRow> = ({ topicName, sentiment = DEFAULT_SENTIMENT }) => {
    const sentimentValues = useMemo<number[]>(
        () =>
            Object.keys(DEFAULT_SENTIMENT)
                .filter((key): key is keyof ISentiment => key in sentiment)
                .map((key) => sentiment[key]),
        [sentiment],
    );

    const allPrompts = sentimentValues.reduce<number>((acc, value) => acc + value, 0);

    const formatTooltipValue = (percentage: number): string => {
        return abbrNumberFilter()(percentage * allPrompts) as string;
    };

    return (
        <ShareBarCell
            values={sentimentValues.map((value) => (allPrompts ? value / allPrompts : 0))}
            colorSet={Object.values(SENTIMENT_COLOR_SET)}
            labelThreshold={0.01}
            height="32px"
            tooltip={{
                title: topicName,
                valueFormatter: formatTooltipValue,
                labels: [
                    translate("llm.sentiment_analysis.topics.column.my-sentiment.tooltip.label.positive"),
                    translate("llm.sentiment_analysis.topics.column.my-sentiment.tooltip.label.neutral"),
                    translate("llm.sentiment_analysis.topics.column.my-sentiment.tooltip.label.negative"),
                ],
            }}
        />
    );
};
